export const acessibilidadeEs = {
  kanban: {
    papel: 'tarjeta arrastrable',
    instrucoes: 'Enter abre la tarjeta. Espacio toma la tarjeta; las flechas izquierda y derecha eligen la columna; Espacio la suelta y Esc cancela.',
    inicio: 'Tomó la tarjeta {{titulo}}. Usa las flechas para elegir la columna.',
    sobre: 'Tarjeta {{titulo}} sobre la columna {{coluna}}.',
    solto: 'Tarjeta {{titulo}} soltada en la columna {{coluna}}.',
    soltoFora: 'Tarjeta {{titulo}} soltada fuera de una columna y devuelta a su lugar.',
    cancelado: 'Movimiento cancelado. La tarjeta {{titulo}} volvió a su lugar.',
    cartao: 'tarjeta',
    colunas: 'Columnas del tablero',
    colunaPapel: 'columna arrastrable',
    moverColuna: 'Mover la columna {{coluna}}',
    instrucoesColuna: 'Espacio toma la columna; las flechas izquierda y derecha eligen la posición; Espacio la suelta y Esc cancela. Alt con la flecha izquierda o derecha cambia la columna de lugar directamente.',
    colunaInicio: 'Tomó la columna {{coluna}}. Usa las flechas para elegir la posición.',
    colunaSobre: 'Columna {{coluna}} en el lugar de la columna {{destino}}.',
    colunaSolta: 'Columna {{coluna}} llevada al lugar de la columna {{destino}}.',
    colunaCancelada: 'Movimiento cancelado. La columna {{coluna}} volvió a su lugar.',
  },
  pular: { conteudo: 'Saltar al contenido' },
  tema: { escuro: 'Tema oscuro', atual: 'Tema actual: {{tema}}. Haz clic para cambiar.' },
  avisos: { regiao: 'Avisos (F8 lleva al aviso más reciente)', fechar: 'Cerrar aviso' },
  calendario: { diaInteiro: 'Todo el día', eventos_one: '{{count}} evento', eventos_other: '{{count}} eventos', eventosDoDia: 'Eventos del {{data}}', eventosDoHorario: 'Eventos del {{data}}, {{hora}}', criarEm: 'Crear el {{quando}}', mostrarMais: 'Mostrar {{n}} más (faltan {{total}})' },
  busca: {
    resultados_one: '{{count}} resultado',
    resultados_other: '{{count}} resultados',
  },
};
